/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Delete_ConfirmInputs */



/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Preset_Manager_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_delete_confirm = /** @type {((inputs?: Preset_Manager_Delete_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Delete_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eliminare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("消去")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मिटाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir")
	return /** @type {LocalizedString} */ ("Delete")
});